import React from 'react';
import { useGoogleFormModal } from '../App';

const TestimonialTwo = () => {
  const { openGoogleFormModal } = useGoogleFormModal();
  return (
    <section className="testimonial-two" id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Become a C2 Member</span>
            <div className="section-title-shape">
              <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
            </div>
          </div>
          <h2 className="section-title__title">Join the Movement</h2>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="testimonial-two__single">
              <div className="testimonial-two__single-inner">
                <p className="testimonial-two__text">Ready to connect with fellow creatives, grow your skills, and create impactful work? Join Create & Commune today and become part of Africa’s new creative wave.
                </p>
                <div className="testimonial-two__client-info">
                  <button
                    onClick={openGoogleFormModal}
                    className="thm-btn"
                    style={{
                      border: 'none',
                      padding: 20,
                      font: 'inherit',
                      cursor: 'pointer'
                    }}
                  >
                    Join the Movement
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialTwo;
